import {
  borderWidths,
  colors,
  gap,
  gutter,
  opacity,
  radius,
  Search,
  spacing,
  typography,
} from '@lamimed/pantheon';
import { rgba } from 'polished';
import styled from 'styled-components';

export const ModalEditableArea = styled.section`
  display: grid;
  gap: ${gutter.small};
  grid-template-columns: 1.8rem 1fr 1.8rem;
  align-items: center;
  margin-bottom: ${spacing.small};
  cursor: pointer;
`;

export const ModalContent = styled.div`
  display: grid;
  gap: ${spacing.medium};
  text-align: center;
`;

export const SearchGroup = styled.div`
  position: relative;
`;

export const SearchIcon = styled(Search).attrs({
  width: 24,
  height: 24,
  color: 'secondary',
})`
  position: absolute;
  top: 50%;
  right: ${gutter.small};
  transform: translateY(-50%);
`;

export const SearchField = styled.input.attrs({
  type: 'text',
})`
  background-color: ${colors.neutral_extra_light};
  border-radius: ${radius.small};
  border: ${borderWidths.small} solid transparent;
  display: block;
  height: 4rem;
  outline: 0;
  padding: 0 4rem 0 ${gutter.small};
  transition: all 0.25s ease;
  width: 100%;

  ${typography.body_text_2};

  ::placeholder {
    color: ${colors.text__highlight};
    opacity: 1;
  }

  &:focus {
    background-color: transparent;
    border-color: ${colors.secondary};
  }
`;

export const SearchBox = styled.ul`
  background-color: ${colors.neutral_extra_light};
  border-radius: ${radius.small};
  list-style: none;
  max-height: 26rem;
  height: 26rem;
  overflow-y: auto;
  padding: ${gutter.default} 0;
  text-align: left;

  ::-webkit-scrollbar {
    width: 0.6rem;
    background: transparent;
  }

  ::-webkit-scrollbar-button {
    opacity: 0;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.secondary};
    border-radius: ${radius.medium};
  }
`;

export const SearchBoxItem = styled.li`
  cursor: default;
  padding: ${gutter.small} ${gutter.default};
  transition: all 0.25s ease;

  ${typography.body_text_2};

  &:hover {
    background-color: ${rgba(colors.light, opacity.hard)};
    color: ${colors.text__highlight};
  }
`;

export const Empty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding-bottom: ${spacing.small};

  ${gap(gutter.small)};

  > * {
    color: ${colors.neutral};
  }
`;
